export const translations = {
  descricao: {
    pt: 'Descrição',
    en: 'Description',
    de: 'Beschreibung',
    es: 'Descripción',
  },
  codigo: {
    pt: 'Código',
    en: 'Code',
    de: 'Code',
    es: 'Código ',
  },
  attribuition: {
    pt: 'Origem',
    en: 'Assigned',
    de: 'Zugewiesen',
    es: 'Asignado',
  },
  lob: {
    pt: 'LOB',
    en: 'LOB',
    de: 'LOB',
    es: 'LOB',
  },
};
